module.exports = __webpack_public_path__ + "img/ZAR10026.c79fdee7.png";